import { handleActions } from 'redux-actions';

import actions from 'state/settings/actionCreators';
import initialState from 'state/settings/initial.state';

const reducer = handleActions(
  {
    [actions.setCountrySettings]: (
      state,
      { payload: { countrySettings } }
    ) => ({
      ...state,
      country: countrySettings,
    }),
    [actions.setFeatureFlags]: (state, { payload: { featureFlags } }) => ({
      ...state,
      flags: featureFlags,
    }),
    [actions.setInviteUserModalOpened]: (state, { payload: { open } }) => ({
      ...state,
      inviteUserModalOpened: open,
    }),
  },
  initialState
);

export default reducer;
